import toJSON from 'cerebral-module-forms/helpers/toJSON'

function sendGroupMail({ state, output, services }) {
  const formValues = toJSON(state.get('mail.groups.form'))
  services.Http
    .post('/api/mail/groups', formValues)
    .then(output.success)
    .catch(output.error)
}

sendGroupMail.async = true
export default sendGroupMail



// WEBPACK FOOTER //
// ./src/modules/mail/actions/sendGroupMail.js